const columns = [
  {
    title: "Tanggal",
    dataIndex: "tanggal",
    key: "tanggal",
  },
  {
    title: "No. Akun",
    dataIndex: "noAcc",
    key: "noAcc",
  },
  {
    title: "Nama Akun",
    dataIndex: "nameAcc",
    key: "nameAcc",
  },
  {
    title: "Keterangan",
    dataIndex: "keterangan",
    key: "keterangan",
  },
  {
    title: "DEBET",
    dataIndex: "debet",
    key: "debet",
  },
  {
    title: "KREDIT",
    dataIndex: "kredit",
    key: "kredit",
  },
  {
    title: "SALDO",
    dataIndex: "saldo",
    key: "saldo",
  },
];

const dataForm = [
  [
    {
      label: "Nomor Akun",
      key: "noAcc",
      placeholder: "Masukan Nomor Akun",
      type: "text",
    },
    {
      label: "Nama Akun",
      key: "nameAcc",
      placeholder: "Masukan Nama Akun",
      type: "text",
    },
  ],
  [
    {
      label: "Kode",
      key: "kode",
      placeholder: "Kode",
      type: "text",
    },
    {
      label: "Kolom",
      key: "kolom",
      placeholder: "Kolom",
      type: "number",
    },
  ],
  {
    label: "Keterangan",
    key: "keterangan",
    placeholder: "Keterangan",
    type: "textarea",
  },
];

export { columns, dataForm };
